import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorResponse } from './ErrorResponse';
import { HrMaxPrice } from './HrMaxPrice';
import { mapHrMaxPrice } from './mapHrMaxPrice';
import { Update } from './Update';

export interface Result {
	hrMaxPrice: HrMaxPrice;
}

export const updateHrMaxPrice = async (
	client: ApiClient,
	userId: string,
	groupId: string,
	update: Update
): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/hr-max-price');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }), {
			body: JSON.stringify({
				products: update.products.map((product) => ({
					id: product.id,
					packageSizeForCalculation: product.packageSizeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					priceTypeForCalculation: product.priceTypeForCalculation,
					selected: product.selected,
					amountOfSubstanceInUnit: product.amountOfSubstanceInUnit,
				})),
				reference: {
					packageSize: update.packageSize,
					referenceBasketVersion: update.referenceBasketVersion,
					referencedProductType: update.referencedProductType,
					historicProductDataViewDate:
						update.historicProductDataViewDate !== null ? formatApiDate(update.historicProductDataViewDate) : null,
					amountOfSubstanceInUnit: update.amountOfSubstanceInUnit,
				},
			}),
			method: 'POST',
		});
		const response = await request.json();
		return {
			hrMaxPrice: mapHrMaxPrice(response.hrMaxPrice),
		};
	} catch (error) {
		if (error instanceof ApiClientErrorResponse) {
			throw new ErrorResponse(error.request, error.statusCode, error.errors);
		}
		throw error;
	}
};
